var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotPagaTuPrestamo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 12,
    width: 77,
    height: 77
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.8889 12.5556H-1.11111V88.5556H74.8889V12.5556Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4144 88.5556H35.3635C31.787 88.5556 28.8889 85.569 28.8889 81.8834V76.0372V64.3449V19.2278C28.8889 15.5422 31.787 12.5556 35.3635 12.5556H68.4144C71.9908 12.5556 74.8889 15.5422 74.8889 19.2278V81.8834C74.8889 85.569 71.9908 88.5556 68.4144 88.5556ZM31.7254 78.9602V81.8834C31.7254 83.9804 33.3903 85.6325 35.3635 85.6325H68.4144C70.4493 85.6325 72.0525 83.9804 72.0525 81.8834V19.2278C72.0525 17.1308 70.4493 15.4786 68.4144 15.4786H35.3635C33.3286 15.4786 31.7254 17.1944 31.7254 19.2278V61.4218V78.9602Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8889 82.5556H54.8889",
    stroke: "#424242",
    strokeWidth: 1.66
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8889 19.556C52.8889 20.1081 52.4414 20.5556 51.8885 20.5556C51.3364 20.5556 50.8889 20.1081 50.8889 19.556C50.8889 19.003 51.3364 18.5556 51.8885 18.5556C52.4414 18.5556 52.8889 19.003 52.8889 19.556Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8889 78.5556L68.8889 78.5162V22.5556H34.8889V78.5556Z",
    fill: "#FF8300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8889 40.3296C46.2506 40.3296 41.663 44.9171 41.663 50.5551C41.663 56.1941 46.2506 60.7816 51.8889 60.7816C57.5272 60.7816 62.1148 56.1941 62.1148 50.5551C62.1148 44.9171 57.5272 40.3296 51.8889 40.3296ZM51.8889 63.5556C44.7202 63.5556 38.8889 57.7236 38.8889 50.5551C38.8889 43.3876 44.7202 37.5556 51.8889 37.5556C59.0576 37.5556 64.8889 43.3876 64.8889 50.5551C64.8889 57.7236 59.0576 63.5556 51.8889 63.5556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8889 56.5555V48.5555",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8889 20.5556H22.8889V24.5556H28.8889V20.5556Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8889 48.5555H3.88889V52.5555H11.8889V48.5555Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.888886 48.5555H-1.11111V52.5555H0.888886V48.5555Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88889 76.5556H2.88889V80.5556H5.88889V76.5556Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8889 76.5556H8.88889V80.5556H16.8889V76.5556Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88889 34.5556H2.88889V38.5556H5.88889V34.5556Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8889 62.5555H14.8889V66.5555H24.8889V62.5555Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8889 34.5556H8.88889V38.5556H28.8889V34.5556Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8889 48.5555H14.8889V52.5555H28.8889V48.5555Z",
    fill: "#424242"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotPagaTuPrestamo);
export default __webpack_public_path__ + "static/media/notPagaTuPrestamo.01409287066f4ae06d70ca49d5a7e816.svg";
export { ForwardRef as ReactComponent };